export enum CourseStatus {
  NOT_STARTED = 'not started',
  NOT_MASTERED = 'not mastered',
  MASTERED = 'mastered',
}
